import type { SolutionProcessTrpcApi } from '@ipen-portal/plugin-solution-process-backend';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';

import { createApiRef } from '@backstage/frontend-plugin-api';

export const solutionProcessApiRef = createApiRef<
  TRPCOptionsProxy<SolutionProcessTrpcApi>
>().with({
  id: 'plugin.ipen.solution-process.api',
});
